// Shows each file of an attachments form (AttachmentsComponent) as it uploads
// straight to Active Storage: a progress bar per file, marked when it fails.
import { Controller } from "@hotwired/stimulus";

interface DirectUploadDetail {
  id: number;
  file?: File;
  progress?: number;
  error?: string;
}

export default class AttachmentUploadController extends Controller<HTMLFormElement> {
  static override targets = ["list"];

  declare readonly listTarget: HTMLUListElement;

  override connect(): void {
    this.element.addEventListener("direct-upload:initialize", this.addUpload);
    this.element.addEventListener("direct-upload:progress", this.progress);
    this.element.addEventListener("direct-upload:error", this.error);
  }

  override disconnect(): void {
    this.element.removeEventListener("direct-upload:initialize", this.addUpload);
    this.element.removeEventListener("direct-upload:progress", this.progress);
    this.element.removeEventListener("direct-upload:error", this.error);
  }

  private addUpload = (event: Event): void => {
    const { id, file } = (event as CustomEvent<DirectUploadDetail>).detail;
    const item = document.createElement("li");
    item.id = this.itemId(id);
    item.className = "flex flex-col gap-1 text-sm";

    const name = document.createElement("span");
    name.textContent = file?.name ?? "";

    const bar = document.createElement("progress");
    bar.className = "w-full";
    bar.max = 100;
    bar.value = 0;

    item.append(name, bar);
    this.listTarget.append(item);
  };

  private progress = (event: Event): void => {
    const { id, progress } = (event as CustomEvent<DirectUploadDetail>).detail;
    const bar = document.getElementById(this.itemId(id))?.querySelector("progress");
    if (bar) bar.value = progress ?? 0;
  };

  private error = (event: Event): void => {
    event.preventDefault();
    const { id, error } = (event as CustomEvent<DirectUploadDetail>).detail;
    const item = document.getElementById(this.itemId(id));
    if (!item) return;

    item.classList.add("text-red-600");
    item.append(error ?? "");
  };

  private itemId(id: number): string {
    return `direct-upload-${id}`;
  }
}
